import { CHANGE_THEME } from './actions';
import dark from './dark';

export default function reducer(state = dark, action) {
  if (action.type === CHANGE_THEME) {
    return action.payload;
  }
  return state;
}
